<template lang="pug">
  .layout-view.farm-history
    .layout-view__controls(v-if="allowView")
      v-btn(
        :medium="!isMobile"
        :fab="isMobile"
        :yellow="hasDateFilters"
        @click="openFilters")
        v-icon(
          :position-left="!isMobile"
          :class="{ 'mr-1': !isMobile }"
          font-size="1"
          icon="filter")
        span(v-if="!isMobile") {{ 'reports.add_filters' | translate }}

    v-dialog(
      max-width="400"
      v-model="showFilters")
      v-card
        v-card-title
          h2.modal-title {{ 'base.filter' | translate }}
        v-card-content
          .cols-x
            .cols-x__2
              v-date-field(
                :label="$t('reports.date_from')"
                v-model="form.history_date_after")
            .cols-x__2
              v-date-field(
                :label="$t('reports.date_to')"
                :min-date="form.history_date_after"
                v-model="form.history_date_before")
        v-card-actions
          v-btn(
            :disabled="invalidDateRange"
            @click="applyFilters") {{ 'base.apply' | translate }}
          v-btn(
            text
            @click="resetFilters") {{ 'base.clear' | translate }}

    router-view(:key="historyViewKey")
</template>

<script>
import adaptationMixin from '@/mixins/adaptation.mixin.js'
import { getDateForDatePicker } from '@/util'

export default {
  name: 'FarmHistory',

  mixins: [adaptationMixin],

  created () {
    if (this.hasDateFilters) return
    const today = getDateForDatePicker(this.$store.getters['account/timezone'])
    const startDate = new Date(`${today}T00:00:00Z`)
    startDate.setUTCDate(startDate.getUTCDate() - 90)
    this.$store.dispatch('history/applyDateFilters', {
      history_date_after: startDate.toISOString().slice(0, 10),
      history_date_before: today
    })
  },

  data: () => ({
    showFilters: false,
    form: {
      history_date_after: null,
      history_date_before: null
    }
  }),

  computed: {
    allowView () {
      return this.hasPermission('history', 'view')
    },

    dateFilters () {
      return this.$store.getters['history/dateFilters']
    },

    hasDateFilters () {
      return Boolean(this.dateFilters.history_date_after || this.dateFilters.history_date_before)
    },

    invalidDateRange () {
      return Boolean(this.form.history_date_after && this.form.history_date_before &&
        this.form.history_date_after > this.form.history_date_before)
    },

    historyViewKey () {
      return JSON.stringify([this.$route.path, this.dateFilters])
    }
  },

  methods: {
    openFilters () {
      this.form = {
        history_date_after: this.dateFilters.history_date_after || null,
        history_date_before: this.dateFilters.history_date_before || null
      }
      this.showFilters = true
    },

    applyFilters () {
      if (this.invalidDateRange) return
      this.$store.dispatch('history/applyDateFilters', this.form)
      this.showFilters = false
    },

    resetFilters () {
      this.form = { history_date_after: null, history_date_before: null }
      this.$store.dispatch('history/applyDateFilters', {})
      this.showFilters = false
    }
  }
}
</script>

<style lang="scss" scoped>
.v-card__actions {
  display: flex;
  gap: 1rem;
}
</style>
